import { useEffect, useRef } from "react";
import { styled } from "@mui/material";
import clsx from "clsx";

const TruncatedSpan = styled("span")({
  overflow: "hidden",
  whiteSpace: "nowrap",
});
const TruncatedItems = ({ items = [], className, splitter = ", " }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const updateDisplayText = () => {
      if (!containerRef.current) return;

      const containerWidth = containerRef.current.offsetWidth; // Reserve space for ellipsis and count
      const fullText = items.join(", ");
      let truncatedText = "";
      let hiddenCount = 0;

      for (let i = 1; i <= fullText.length; i++) {
        truncatedText = fullText.slice(0, i);
        containerRef.current.textContent = `${truncatedText}... +XY`;

        if (containerRef.current.scrollWidth > containerWidth) {
          hiddenCount = items.length - truncatedText.split(", ").length;
          truncatedText = fullText.slice(0, i - 1);
          break;
        }
      }

      if (hiddenCount > 0) {
        if (hiddenCount > 99) {
          hiddenCount = "99";
        }
        truncatedText += `... +${hiddenCount}`;
      }
      containerRef.current.textContent = truncatedText;
    };

    updateDisplayText();

    window.addEventListener("resize", updateDisplayText);
    return () => window.removeEventListener("resize", updateDisplayText);
  }, [items, splitter]);

  return <TruncatedSpan className={clsx(className)} ref={containerRef} />;
};

export default TruncatedItems;
